import { render, staticRenderFns } from "./UpsertCalloutsModal.vue?vue&type=template&id=16d99ad8&scoped=true"
import script from "./UpsertCalloutsModal.vue?vue&type=script&lang=js"
export * from "./UpsertCalloutsModal.vue?vue&type=script&lang=js"
import style0 from "./UpsertCalloutsModal.vue?vue&type=style&index=0&id=16d99ad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d99ad8",
  null
  
)

export default component.exports